import { RpcSeek, RpcSeekResult } from './rpc-seek-model';

/**
 * Rpc seek sever side handler interface.
 */
export interface RpcSeekHandler {
    handler(data: RpcSeek): Promise<RpcSeekResult>;
}
